import $ from "jquery";
import React from "react";
import { Row, Column, Button } from "react-foundation";

import Star from "components/Star";

import "css/GoogleReviews.css";
import Popup from "./Popup";

const round = (value, precision) => {
    var multiplier = Math.pow(10, precision || 0);
    return Math.round(value * multiplier) / multiplier;
};

const ReviewStars = ({ rating = 0, large = false }) => {
    return (
        <span className="review-stars-container small">
            <Star starOn={rating > 0} large={large} />
            <nbsp />
            <Star starOn={rating > 1} large={large} />
            <nbsp />
            <Star starOn={rating > 2} large={large} />
            <nbsp />
            <Star starOn={rating > 3} large={large} />
            <nbsp />
            <Star starOn={rating > 4} large={large} />
        </span>
    );
};

const GoogleReview = ({ review }) => {
    return (
        <Row className="review-row">
            <Column small={1}>
                <a href={review.author_url}>
                    <img src={review.profile_photo_url} alt="" />
                </a>
            </Column>
            <Column small={11}>
                <h4>{review.author_name}</h4>
                <p>
                    <ReviewStars rating={review.rating} />
                    <small>{review.relative_time_description}</small>
                </p>
                <p>{review.text}</p>
            </Column>
        </Row>
    );
};

const GoogleReviewList = ({ name, googleReviews }) => {
    let review_count = (googleReviews && googleReviews.length) || 0;

    let total_review_score = 0;

    for (var i = 0; i < review_count; i++) {
        total_review_score += googleReviews[i].rating;
    }

    let avg_review_score = round(total_review_score / review_count);

    return (
        <div className="GoogleReviewList">
            <h2 className="leftAlign">{name}</h2>
            <div className="review-score-row">
                <div>
                    <span className="average-review-score">{avg_review_score}</span>
                    <ReviewStars rating={avg_review_score} large={true} /> <small className="rating-from-google">{"RATING FROM " + review_count + " GOOGLE REVIEWS"}</small>
                </div>
            </div>

            {$.map(googleReviews, review => {
                return <GoogleReview key={review.author_name} review={review} />;
            })}
        </div>
    );
};

const NoReviews = () => <div className="NoReviews">No Reviews</div>;

const GoogleReviews = ({ reviews, companyName }) => {
    if (!reviews || reviews.length === 0) {
        return <NoReviews />;
    }

    let goodReviews = reviews.filter(review=>review.rating >= 3);

    let review = goodReviews[0];

    return (
        <div className="GoogleReviews">
            <div className={"reviews-global-rating clearfix"}>
                <span className="float-left">GOOGLE REVIEW</span>
                <span className="float-right">
                    <ReviewStars rating={review.rating} />
                </span>
            </div>
            <div>
                {goodReviews.length > 0 && (
                    <Popup component={GoogleReviewList} name={companyName} googleReviews={goodReviews}>
                        <Button type="button" className="more-button hollow grey float-right">MORE</Button>
                    </Popup>
                )}
            </div>
        </div>
    );
};

export default GoogleReviews;



// WEBPACK FOOTER //
// ./src/components/GoogleReviews.js